<header class="container-fluid">
  <div class="row justify-content-between align-items-center py-2">
    <div class="col-3 text-start d-flex align-items-center">
      <fa-icon
        [icon]="faShoppingBag"
        class="me-4"
        style="font-size: 20px"
        [routerLink]="['/Cart']"
      ></fa-icon>
    </div>

    <div class="col-6 text-center brand-name">
      <img
        src="assets/img/logo.png"
        alt="Logo"
        class="img-fluid"
        [routerLink]="['/']"
      />
    </div>

    <div class="col-3 d-flex align-items-center justify-content-end">
      <!--<fa-icon [icon]="faSearch" (click)="showSearch()"></fa-icon>-->

      <!--<app-search *ngIf="isSearchVisible" (closeSearch)="hideSearch()" />-->
      <div class="dropdown me-4">
        <button
          class="btn btn-dark dropdown"
          type="button"
          id="languageDropdown"     
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          {{ language | uppercase }}
        </button>
        <ul
          class="dropdown-menu dropdown-menu-end text-center w-25"
          aria-labelledby="languageDropdown"
        >
          <li>
            <a class="dropdown-item" (click)="changeLanguage('en')">EN</a>
          </li>
          <li>
            <a class="dropdown-item" (click)="changeLanguage('ar')">AR</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</header>
<app-navlink />
